import { ETripEvent, ITripEvent } from 'detailsv2/structure';
import { Maybe } from 'utils/types';

export type DateString = string; // yyyy-MM-dd

export type TCalendarDay = {
  dayNumber: number;
  date: Maybe<DateString>;
};

export enum EDaySlotType {
  empty = 'empty',
  event = 'event',
}

export type Period = TCalendarDay[];

export type DaySlot<V extends EDaySlotType> = {
  type: V;
  position: number;
  data: DaySlotDataMap[V];
};

export type AvailableSlot = DaySlot<EDaySlotType.event> | DaySlot<EDaySlotType.empty>;

export interface DaySlots extends Pick<TCalendarDay, 'dayNumber'> {
  slots: AvailableSlot[];
}

/**
 * Discriminated union of all trip events with a reduced number of properties for the calendar.
 */
export type CalendarEvent = {
  [K in ETripEvent]: Pick<
    ITripEvent<K>,
    'id' | 'type' | 'data' | 'daysRange' | 'datesRange' | 'positions' | 'attachedPages' | 'icon'
  > & { temp?: boolean };
}[ETripEvent];

type DaySlotDataMap = {
  [EDaySlotType.event]: CalendarEvent;
  [EDaySlotType.empty]: null;
};
